import { useServer } from "../../server/ServerContext";

/**
 * Fetch a list of applications
 * @param options useQuery options
 * @returns useQuery result
 */
export const useScriptheroEnrollmentUrl = (
  pharmacyId: string,
  medicationRecordId: string
) => {
  const server = useServer();

  return `${server.defaults.baseURL}/scripthero/enrollment_redirect?pharmacy_id=${pharmacyId}&medication_record_id=${medicationRecordId}`;

  // TODO: switch to this syntax pending: https://github.com/axios/axios/pull/3737
  // return server.getUri({
  //   url: `scripthero/enrollment_redirect?pharmacy_id=${pharmacyId}&medication_record_id=${medicationRecordId}`,
  // });
};

export default useScriptheroEnrollmentUrl;
